import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { UserModule } from '@/store/modules/user'

const serviceBlob = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 15000
})

// Request interceptors
serviceBlob.interceptors.request.use(
  (config) => {
    if (UserModule.token) {
      config.headers['Authorization'] = 'Bearer ' + UserModule.token
    }
    config.responseType = 'blob'
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// Response interceptors
serviceBlob.interceptors.response.use(
  (response) => {
    // Some example codes here:
    // code == 20000: success
    // code == 50001: invalid access token
    // code == 50002: already login in other place
    // code == 50003: access token expired
    // code == 50004: invalid user (user not exist)
    // code == 50005: username or password is incorrect
    // You can change this part for your own usage.

    const file = response.headers['content-disposition']
    const fileName = file.split(';')[1].split('filename=')[1]
    response['fileName'] = decodeURI(fileName)
    if (response.status == 200) {
      return response
    } else {
      return Promise.reject(new Error('Error'))
    }
  },
  (error) => {
    Message({
      message: error.message,
      type: 'error',
      duration: 15 * 1000
    })
    return Promise.reject(error)
  }
)

export default serviceBlob
